export default __webpack_public_path__ + "static/media/va2012mv.e96f6ff2.jpg";